import { APIDataDocumentHistory, APIDataBlueUser, APIMetaDataDocumentHistoryPropertyNames } from '@evertel/types'
import { Store } from '@evertel/types'
import { decorate, injectable } from '@evertel/di'

interface APIDataDocumentHistoryEntry extends APIDataDocumentHistory {
    id: number
    objectId?: number
    blueUserId?: number
    createdBy?: APIDataBlueUser
}

class DocumentHistoryStore extends Store<APIDataDocumentHistoryEntry> {
    constructor() {
        super([...APIMetaDataDocumentHistoryPropertyNames, 'id', 'objectId', 'blueUserId', 'createdBy'])
    }
}

decorate(injectable(), DocumentHistoryStore)

export { DocumentHistoryStore, APIDataDocumentHistoryEntry }
